// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrone-tooltip {
  position: absolute;
  pointer-events: none;
  max-width: 300px;
  width: max-content;
  word-break: break-word;
  opacity: 0;
  transition: opacity 150ms ease;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.18));
}
.hrone-tooltip.hrone-tooltip--visible {
  opacity: 1;
}
.hrone-tooltip__content {
  background-color: var(--theme-backgroundPrimary);
  border-radius: 6px;
  box-shadow: 0px 4px 16px 0px rgba(20, 30, 25, 0.0588235294), 0px 0px 0px 1px rgba(20, 30, 25, 0.0509803922);
  padding-left: 8px;
  padding-top: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  font-size: 9px;
  letter-spacing: 0.4px;
  font-weight: 600;
  white-space: pre-wrap;
}
.hrone-tooltip__text {
  color: var(--theme-contentSecondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
.hrone-tooltip__arrow {
  position: absolute;
  width: 0;
  height: 0;
}
.hrone-tooltip.hrone-tooltip-md .hrone-tooltip__content {
  padding: 12px;
}
.hrone-tooltip.hrone-tooltip-md .hrone-tooltip__content .hrone-tooltip__text {
  font-size: 14px;
}
.hrone-tooltip.hrone-tooltip-lg .hrone-tooltip__content {
  padding: 16px;
}
.hrone-tooltip.hrone-tooltip-lg .hrone-tooltip__content .hrone-tooltip__text {
  font-size: 16px;
  line-height: 20px;
}

.hrone-tooltip[data-pos=top] .hrone-tooltip__arrow {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: var(--theme-backgroundPrimary);
  border-bottom-width: 0;
}

.hrone-tooltip[data-pos=bottom] .hrone-tooltip__arrow {
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-bottom-color: var(--theme-backgroundPrimary);
  border-top-width: 0;
}

.hrone-tooltip[data-pos=left] .hrone-tooltip__arrow {
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-left-color: var(--theme-backgroundPrimary);
  border-right-width: 0;
}

.hrone-tooltip[data-pos=right] .hrone-tooltip__arrow {
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: var(--theme-backgroundPrimary);
  border-left-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/hrone-ui-library/hrone-tooltip/hrone-tooltip.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,8BAAA;EACA,kDAAA;AADF;AAGE;EACE,UAAA;AADJ;AAIE;EACE,gDAAA;EACA,kBAAA;EACA,2GAAA;EAEA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AAHJ;AAKE;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAJJ;AAQI;EACE,aAAA;AANN;AAQM;EACE,eAAA;AANR;AAWI;EACE,aAAA;AATN;AAWM;EACE,eAAA;EACA,iBAAA;AATR;;AAuBE;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,gDAAA;EACA,sBAAA;AApBJ;;AA0BE;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,mDAAA;EACA,mBAAA;AAvBJ;;AA6BE;EACE,WAAA;EACA,QAAA;EACA,2BAAA;EACA,6BAAA;EACA,iDAAA;EACA,qBAAA;AA1BJ;;AAgCE;EACE,UAAA;EACA,QAAA;EACA,2BAAA;EACA,6BAAA;EACA,kDAAA;EACA,oBAAA;AA7BJ","sourcesContent":["// HroneTooltip — fully custom styles, zero dependency on PrimeNG \n\n.hrone-tooltip {\n  position: absolute;\n  pointer-events: none;\n  max-width: 300px;\n  width: max-content;\n  word-break: break-word;\n  opacity: 0;\n  transition: opacity 150ms ease; \n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.18));\n\n  &.hrone-tooltip--visible {\n    opacity: 1;\n  }\n\n  &__content {\n    background-color: var(--theme-backgroundPrimary); \n    border-radius: 6px;\n    box-shadow: 0px 4px 16px 0px #141E190F, \n                0px 0px 0px 1px #141E190D;\n    padding-left: 8px;\n    padding-top: 8px;\n    padding-right: 8px;\n    padding-bottom: 8px;\n    font-size: 9px;\n    letter-spacing: 0.4px;\n    font-weight: 600;\n    white-space: pre-wrap;\n  }\n  &__text{\n    color: var(--theme-contentSecondary);\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n\n  &__arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n  } \n   \n  &.hrone-tooltip-md{\n    .hrone-tooltip__content{\n      padding: 12px;  \n\n      .hrone-tooltip__text{\n        font-size: 14px;\n      }\n    }\n  }\n  &.hrone-tooltip-lg{\n    .hrone-tooltip__content{\n      padding: 16px;  \n\n      .hrone-tooltip__text{\n        font-size: 16px;\n        line-height: 20px;\n      }\n    }\n  }\n}\n\n// ── Arrow directions + per-position directional shadow ────────────────────────\n// filter: drop-shadow() is used instead of box-shadow because the arrow is a\n// CSS border trick (zero width/height element) — box-shadow has no effect on it.\n// drop-shadow renders on the full composite shape including the arrow triangle.\n// Shadow direction is flipped per position so it always falls away from the host.\n\n.hrone-tooltip[data-pos='top'] { \n\n  .hrone-tooltip__arrow {\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 6px solid transparent;\n    border-top-color: var(--theme-backgroundPrimary);\n    border-bottom-width: 0;\n  }\n}\n\n.hrone-tooltip[data-pos='bottom'] { \n\n  .hrone-tooltip__arrow {\n    top: -6px;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 6px solid transparent;\n    border-bottom-color: var(--theme-backgroundPrimary);\n    border-top-width: 0;\n  }\n}\n\n.hrone-tooltip[data-pos='left'] { \n\n  .hrone-tooltip__arrow {\n    right: -6px;\n    top: 50%;\n    transform: translateY(-50%);\n    border: 6px solid transparent;\n    border-left-color: var(--theme-backgroundPrimary);\n    border-right-width: 0;\n  }\n}\n\n.hrone-tooltip[data-pos='right'] { \n\n  .hrone-tooltip__arrow {\n    left: -6px;\n    top: 50%;\n    transform: translateY(-50%);\n    border: 6px solid transparent;\n    border-right-color: var(--theme-backgroundPrimary);\n    border-left-width: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
